/**
 * Fonts a Growth-plan brand can pick for its embeds, dashboard and LO page.
 * `id` is the key the monolith stores in `font_family`; "" means Default
 * (today's look). Keep in sync with the backend allow-list.
 */
export const BRAND_FONT_OPTIONS = [
  { id: "", name: "Default" },
  { id: "roboto", name: "Roboto" },
  { id: "open_sans", name: "Open Sans" },
  { id: "google_sans", name: "Google Sans" },
  { id: "montserrat", name: "Montserrat" },
  { id: "inter", name: "Inter" },
  { id: "poppins", name: "Poppins" },
  { id: "source_sans_3", name: "Source Sans 3" },
  { id: "arimo", name: "Arimo" },
  { id: "roboto_condensed", name: "Roboto Condensed" }
] as const

/** Only weight 500 is shipped for brand fonts. */
export const BRAND_FONT_WEIGHT = 500

export const getBrandFontName = (key?: string): string | undefined =>
  key ? BRAND_FONT_OPTIONS.find(f => f.id === key)?.name : undefined
